import { studioAttrValAssocObj } from "../../StudioAttributes/data";
import { Box, List } from "@mui/material";
import { attrTableStrColumnsObj } from "components/PimDashboard/data";
import { inputTypes, arrType } from "data/globalData";
import RenderInputField from "./RenderInputField/RenderInputField";
import { getColDefaultValue } from "components/PimDashboard/data";
import { StudioDashboardState } from "context/StudioDashboardContext";

export const removeDropdownOptionsBasedonDependency = (column, data, options, allAttributes) => {
	if (
		(column[attrTableStrColumnsObj.input_type.key] === inputTypes.SELECT.key ||
			column[attrTableStrColumnsObj.input_type.key] === inputTypes.MULTIPLE_SELECT.key) &&
		options
	) {
		let list = [];
		console.log(column, allAttributes, "columnsd.........");

		let dependentCols = allAttributes?.filter((row) => column?.dependency?.[row.key] === true);

		if (dependentCols?.length) {
			column[studioAttrValAssocObj]?.forEach((attrVal) => {
				let push = true;
				dependentCols.forEach((col) => {
					if (data?.[col?.linked_table][col.key] && data?.[col?.linked_table][col.key] !== getColDefaultValue(col))
						if (attrVal?.dependency?.[col.key]?.includes(data?.[col?.linked_table][col.key])) {
						} else push = false;
				});
				if (push) list.push(attrVal);
			});
		} else list = column[studioAttrValAssocObj];
		if (column.key === "category") console.log(column, dependentCols, list, "dependentCols.........");

		return {
			type: arrType,
			list: list.map((val) => ({ name: val?.value, key: val?.value })),
		};
	} else return {};
};
const RenderAttributeInputs = ({ columns, setData, data, width, attrGrp, errObj, setErrorObj }) => {
	return (
		<Box display="flex" width={width ? width : "100%"} flexWrap="wrap" p={1} columnGap="1%" alignItems="flex-start" rowGap="3px">
			{errObj &&
				columns?.map((column) => (
					<InputItem
						key={data}
						column={column}
						data={data}
						setData={setData}
						attrGrp={attrGrp}
						errObj={errObj}
						setErrorObj={setErrorObj}
					/>
				))}
		</Box>
	);
};
export default RenderAttributeInputs;

const InputItem = ({ column, data, setData, attrGrp, errObj, setErrorObj }) => {
	const { allAttributes } = StudioDashboardState();

	let options = {};
	options = removeDropdownOptionsBasedonDependency(column, data, column?.[studioAttrValAssocObj], allAttributes);

	return (
		<RenderInputField
			column={{ ...column, [studioAttrValAssocObj]: options }}
			data={data}
			setData={setData}
			selectOptObjName={studioAttrValAssocObj}
			width={"24%"}
			longWidth={"49%"}
			attrGrp={attrGrp}
			error={!!errObj?.[column.key]}
			errorObj={errObj}
			setError={setErrorObj}
			// dependencyColData={}
		/>
	);
};
